const sjSharedLibrary = require('@sj/shared-library');


const errorLoggerService = new sjSharedLibrary.ErrorLoggerService('Homepage');

function windowOnError(errorEvent) {
    errorLoggerService.log(errorEvent);

    return false;
}

window.addEventListener('error', windowOnError, false);
